import {useSelector} from "react-redux";
import {getActiveBrandId} from "@Libraries/brands-library.ts";

/**
 *
 * @return {string | null}
 */
export const useActiveBrandId = () => {
    return useSelector(({brands}) => getActiveBrandId(brands));
}
